"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiBadge = getMuiBadge;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var standardStyle = {
  height: '16px',
  padding: '0 6px'
};
function getMuiBadge() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '& .MuiBadge-badge': (0, _extends2["default"])({}, theme.typography['text-xs-medium'])
        };
      }
    },
    variants: [{
      props: {
        color: 'primary'
      },
      style: function (_ref2) {
        var theme = _ref2.theme;
        return {
          '& .MuiBadge-standard': (0, _extends2["default"])({
            backgroundColor: theme.palette.primary[50],
            border: "1px solid ".concat(theme.palette.primary[200]),
            color: theme.palette.primary[700]
          }, standardStyle)
        };
      }
    }, {
      props: {
        color: 'error'
      },
      style: function (_ref3) {
        var theme = _ref3.theme;
        return {
          '& .MuiBadge-standard': (0, _extends2["default"])({
            backgroundColor: theme.palette.error[50],
            border: "1px solid ".concat(theme.palette.error[200]),
            color: theme.palette.error[700]
          }, standardStyle)
        };
      }
    }, {
      props: {
        color: 'primary',
        variant: 'dot'
      },
      style: function (_ref4) {
        var ownerState = _ref4.ownerState,
          theme = _ref4.theme;
        return {
          '& .MuiBadge-dot': {
            backgroundColor: ownerState != null && ownerState.append ? theme.palette.primary[600] : theme.palette.primary[700]
          }
        };
      }
    }, {
      props: {
        color: 'error',
        variant: 'dot'
      },
      style: function (_ref5) {
        var ownerState = _ref5.ownerState,
          theme = _ref5.theme;
        return {
          '& .MuiBadge-dot': {
            backgroundColor: ownerState != null && ownerState.append ? theme.palette.error[600] : theme.palette.error[700]
          }
        };
      }
    }]
  };
}